module.exports = __webpack_public_path__ + "static/media/mysql.c57e7443.svg";